export const COMMIT = 'Commit';
export const FUNCTIONS = 'Functions';
export const EXCEPTIONS = 'Exceptions';

export const OVERALL = 0;
export const COMPONENTS = 1;
export const ComponentGraphs = [OVERALL, COMPONENTS];
export const ComponentGraphNames = ['Overall', 'Functions'];

export const GET = 'GET'
export const CPU = 'CPU'

export const MetricCPU = 0;
export const MetricWaits = 1;
export const MetricExceptions = 2;
export const MetricMemory = 3;
export const MetricSqlCount = 4;
export const MetricSqlDuration = 5;
export const MetricApiCpu = 6;
export const MetricApiDuration = 7;
export const MetricULS = 8;

export const Metrics = [MetricCPU, MetricWaits, MetricExceptions, MetricMemory, MetricSqlCount, MetricSqlDuration, MetricApiCpu, MetricApiDuration];
export const MetricNames = ['CPU', 'Waits', 'Exceptions', 'Memory', 'SQL Count', 'SQL Duration', 'Api ' + String.fromCharCode(956) + 's cpu', 'Api ' + String.fromCharCode(956) +'s', 'ULS events/hour'];

export const MetricsSubTypes = [MetricExceptions, MetricSqlCount, MetricSqlDuration];

export const DEPLOYMENT = 2;
export const FLIGHT = 1;
export const KILLSWITCH = 0;

// Generate farm name text dynamically based on stage and maxStage
export function getFarmDisplayText(environmentName, stage, maxStage) {
    if (stage >= maxStage) {
        return 'All Farms';
    }
    return `All ${environmentName} Farms`;
}


// Generate FarmNameOptions dynamically based on service configuration
export function getFarmNameOptions(service) {
    if (!service || !service.environments) {
        // Fallback to static options if service config is not available
        return getStaticFarmNameOptions();
    }

    const environments = Object.values(service.environments);
    const maxStage = Math.max(...environments.map(env => env.stage || 0), 0);

    const dynamicOptions = [];

    // Add individual option for each environment with value matching environment ID
    environments.forEach(env => {
        const farmKey = env.findMyChangeFarmName || '';
        const displayText = getFarmDisplayText(env.name, env.stage, maxStage);
        dynamicOptions.push({
            key: farmKey,
            text: displayText,
            value: env.id
        });
    });

    // Add combined "All Farms" option for all environments
    const highestEnvId = Math.max(...environments.map(env => env.id), 0);
    dynamicOptions.push({
        key: '',
        text: 'All Farms',
        value: highestEnvId + 1
    });

    // Calculate the starting value for specific farm options
    const specificFarmStartValue = highestEnvId + 2;

    // Add specific farm options (static)
    dynamicOptions.push(
        { key: 'msit_us_1_bl22', text: 'msit_us_1_bl22_82490_content', value: specificFarmStartValue },
        { key: 'msit_us_1_sat10', text: 'msit_us_1_sat10_82492_content', value: specificFarmStartValue + 1 },
        { key: 'msit_us_1_chi21', text: 'msit_us_1_chi21_content', value: specificFarmStartValue + 2 },
        { key: 'msit_us_1_sn1', text: 'msit_us_1_sn1_content', value: specificFarmStartValue + 3 },
        { key: 'msit_spdf_1000_eastus2', text: 'msit_spdf_1000_eastus2_199010_content', value: specificFarmStartValue + 4 },
        { key: 'msit_spdf_1000_eastus', text: 'msit_spdf_1000_eastus_199106_content', value: specificFarmStartValue + 5 },
        { key: 'msit_spdf_1000_centralus', text: 'msit_spdf_1000_centralus_199009_content', value: specificFarmStartValue + 6 }
    );

    return dynamicOptions;
}

// Static fallback for backward compatibility
export function getStaticFarmNameOptions() {
    return [
        { key: 'msit_spdf_1000_', text: 'All SPDF Farms', value: 1 },
        { key: 'msit_us_1', text: 'All MSIT Farms', value: 2 },
        { key: 'US_201_', text: 'All Farms', value: 3 },
        { key: 'US_273_', text: 'All Farms', value: 4 },
        { key: '', text: 'All Farms', value: 5 },
        { key: 'msit_us_1_bl22', text: 'msit_us_1_bl22_82490_content', value: 6 },
        { key: 'msit_us_1_sat10', text: 'msit_us_1_sat10_82492_content', value: 7 },
        { key: 'msit_us_1_chi21', text: 'msit_us_1_chi21_content', value: 8 },
        { key: 'msit_us_1_sn1', text: 'msit_us_1_sn1_content', value: 9 },
        { key: 'msit_spdf_1000_eastus2', text: 'msit_spdf_1000_eastus2_199010_content', value: 10 },
        { key: 'msit_spdf_1000_eastus', text: 'msit_spdf_1000_eastus_199106_content', value: 11 },
        { key: 'msit_spdf_1000_centralus', text: 'msit_spdf_1000_centralus_199009_content', value: 12 },
    ];
}

// Export as constant for backward compatibility
export const FarmNameOptions = getStaticFarmNameOptions();
